

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// createTier
// CREATETIER
const CREATETIER= createAsyncThunk(
  "createTier/createTier",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createTierSlice = createSlice({
  name: "createTierSlice",
  initialState: {
    createTier: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateTier: (state) => {
        state.createTier.loading = false
        state.createTier.error = false
        state.createTier.data = []
        state.createTier.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATETIER.fulfilled, (state, action) => {
      state.createTier = {
        ...state.createTier,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATETIER.pending, (state, action) => {
      state.createTier = {
        ...state.createTier,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATETIER.rejected, (state, action) => {
      state.createTier = {
        ...state.createTier,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createTierAction = {
    CREATETIER,
};

export { createTierAction };
export default createTierSlice.reducer;
export const {setInitialStateOfcreateTier} = createTierSlice.actions
